import { render, staticRenderFns } from "./tdt-search.vue?vue&type=template&id=1bc74acb&"
import script from "./tdt-search.vue?vue&type=script&lang=js&"
export * from "./tdt-search.vue?vue&type=script&lang=js&"
import style0 from "./tdt-search.vue?vue&type=style&index=0&id=1bc74acb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports